
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsBrandTypeDialog extends Serenity.EntityDialog<CsBrandTypeRow, any> {
        protected getFormKey() { return CsBrandTypeForm.formKey; }
        protected getIdProperty() { return CsBrandTypeRow.idProperty; }
        protected getLocalTextPrefix() { return CsBrandTypeRow.localTextPrefix; }
        protected getNameProperty() { return CsBrandTypeRow.nameProperty; }
        protected getService() { return CsBrandTypeService.baseUrl; }
        protected getDeletePermission() { return CsBrandTypeRow.deletePermission; }
        protected getInsertPermission() { return CsBrandTypeRow.insertPermission; }
        protected getUpdatePermission() { return CsBrandTypeRow.updatePermission; }

        protected form = new CsBrandTypeForm(this.idPrefix);

    }
}